import type { Property } from '../../store/types';
import { uid } from '../../store/utils';

const NEW_FIELD_KEY = 'new_output';

// Output keys share one namespace across the plan, and a duplicate blocks publishing, so a new
// output can't reuse a key from any task.
const availableFieldKey = (taken: Set<string>): string => {
  if (!taken.has(NEW_FIELD_KEY)) return NEW_FIELD_KEY;
  let suffix = 2;
  while (taken.has(`${NEW_FIELD_KEY}_${suffix}`)) suffix += 1;
  return `${NEW_FIELD_KEY}_${suffix}`;
};

export type FieldState = {
  uid: string;
  key: string;
  markdown: string;
  typeLabel: string;
  enumValues: string[] | null;
  criteria: Record<string, string> | null;
  children: Property[] | null;
};

export type ArtifactState = {
  uid: string;
  name: string;
  isStarred: boolean;
  mimeType: string | null;
  markdown: string;
};

export type TaskState = {
  kind: 'task';
  id: string;
  name: string;
  markdown: string;
  fields: FieldState[];
  artifacts: ArtifactState[];
};

/** The keys `task` holds now, on top of what the plan held when it last rendered. */
const takenBy = (task: TaskState, taken: Set<string>): Set<string> =>
  new Set([...taken, ...task.fields.map(field => field.key), ...task.artifacts.map(artifact => artifact.uid)]);

export const newField = (task: TaskState, taken: Set<string>): FieldState => {
  return {
    uid: uid('fld'),
    key: availableFieldKey(takenBy(task, taken)),
    markdown: '',
    typeLabel: 'text',
    enumValues: null,
    criteria: null,
    children: null,
  };
};

// The key stays English whatever the display language: it is what later steps and the API read.
